export const leaveQueryKeys = {
  all: ['leave'] as const,
  requests: () => [...leaveQueryKeys.all, 'requests'] as const,
  myRequests: (profileId: string) => [...leaveQueryKeys.requests(), 'my', profileId] as const,
  companyRequests: () => [...leaveQueryKeys.requests(), 'company'] as const,
  companyRequestsFiltered: (employeeId?: string, status?: string, limit?: number, offset?: number) => 
    [...leaveQueryKeys.companyRequests(), 'filtered', employeeId, status, limit, offset] as const,
  employees: () => [...leaveQueryKeys.all, 'employees'] as const,
  
  // Leave Policy Query Keys
  policies: () => [...leaveQueryKeys.all, 'policies'] as const,
  policy: (id: string) => [...leaveQueryKeys.policies(), id] as const,
  policyAssignments: (policyId: string) => [...leaveQueryKeys.policies(), policyId, 'assignments'] as const,
  
  // Leave Balance Query Keys
  balances: (profileId?: string) => profileId 
    ? [...leaveQueryKeys.all, 'balances', profileId] as const 
    : [...leaveQueryKeys.all, 'balances'] as const,
  myBalances: (profileId: string) => [...leaveQueryKeys.balances(), 'my', profileId] as const,
  
  // Policy Dependencies Query Keys
  policyDependencies: (policyId: string) => [...leaveQueryKeys.policies(), policyId, 'dependencies'] as const,
  
  // Conflict Resolution Query Keys (Phase 4)
  conflicts: (profileId: string, startDate: string, endDate: string) =>
    [...leaveQueryKeys.all, 'conflicts', profileId, startDate, endDate] as const,
  eligibleReplacements: (shiftIds: string[]) =>
    [...leaveQueryKeys.all, 'eligibleReplacements', ...shiftIds.sort()] as const,
    
  // Leave Overlay Query Keys (Schedule Integration)
  leaveOverlay: () => [...leaveQueryKeys.all, 'overlay'] as const,
  companyLeaveOverlay: (companyId: string, startDate: string, endDate: string) =>
    [...leaveQueryKeys.leaveOverlay(), 'company', companyId, startDate, endDate] as const,
  myLeaveOverlay: (profileId: string, startDate: string, endDate: string) =>
    [...leaveQueryKeys.leaveOverlay(), 'my', profileId, startDate, endDate] as const,
} as const;
